import PriceSection from './PriceSection'

export default PriceSection
